/**
 * プレビューステップ
 */
import { UserAvatar } from "common/elements";
import I18n from "features/parent/i18n";
import { CreatePlayerState } from "../types";

interface PlayerPreviewStepProps {
  state: CreatePlayerState;
}

export const PlayerPreviewStep = ({ state }: PlayerPreviewStepProps) => {
  return (
    <div className="flex-col-el flex-center w-full h-full py-8">
      {/* タイトル */}
      <div className="flex-col-el flex-center mb-8">
        <p className="text-body text-textcolor-black text-[24px]">
          {I18n.t("MSG_CREATE_USER_TITLE_PREVIEW_BY_PARENT")}
        </p>
      </div>

      {/* プレビュー */}
      <div className="flex-col-el flex-center gap-4 bg-gray2-10 rounded-[16px] p-8">
        {/* アイコン */}
        <div className="flex-col-el flex-center">
          {state.icon ? (
            <UserAvatar size={160} icon={state.icon} />
          ) : (
            <div className="flex-col-el flex-center w-[160px] h-[160px] bg-white rounded-full border-4 border-gray2-40">
              <span className="material-symbols-outlined text-[80px] text-gray2-60">person</span>
            </div>
          )}
        </div>

        {/* 名前 */}
        <div className="flex-col-el flex-center bg-white px-8 py-3 rounded-[24px] border border-gray2-40">
          <p className="text-body text-textcolor-black text-[24px]">{state.name}</p>
        </div>
      </div>

      {/* 確認メッセージ */}
      <p className="text-body text-gray2-80 text-[18px] mt-6">
        {I18n.t("MSG_CREATE_USER_PREVIEW_MESSAGE_BY_PARENT")}
      </p>
    </div>
  );
};
